import { render, staticRenderFns } from "./AboutImsModal.vue?vue&type=template&id=739ee91f&scoped=true"
import script from "./AboutImsModal.vue?vue&type=script&lang=js"
export * from "./AboutImsModal.vue?vue&type=script&lang=js"
import style0 from "./AboutImsModal.vue?vue&type=style&index=0&id=739ee91f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739ee91f",
  null
  
)

export default component.exports